import type { DateRangeType } from "@lemmonhq/types";

/** `"HH:mm"`, 24h. */
export type TimeOfDay = string;

export const DAY_START: TimeOfDay = "00:00";
export const DAY_END: TimeOfDay = "23:59";

export type DateRange = {
  /** Bare `YYYY-MM-DD`. Never carries a time component. */
  startDate: string;
  /** Bare `YYYY-MM-DD`. Never carries a time component. */
  endDate: string;
  type: DateRangeType;
  /**
   * Optional `"HH:mm"` window within the range. Absent means the whole day,
   * so existing callers that only read `startDate`/`endDate` keep working.
   */
  startTime?: TimeOfDay;
  endTime?: TimeOfDay;
};

export type DateRangeOption = {
  value: DateRangeType;
  label: string;
};

/** True when the range covers whole days, i.e. the time window adds nothing. */
export const isWholeDayRange = (range: DateRange) =>
  (range.startTime ?? DAY_START) === DAY_START &&
  (range.endTime ?? DAY_END) === DAY_END;
